import signin, { signinIntegradora } from '../signin'
import { getSystemTokenBFF } from 'utils/systemTokens'
import { generateAndGetCorrelationId } from 'utils/make'
import isClient from 'utils/isClient'

/* Foi necessária a adição da função recursiva, para garantir que teremos o annonymous_)id */
const waitAnnonymousId = async (tries = 10) => {
  return new Promise((resolve) => {
    const annonymousIdInterval = setInterval(async () => {
      if (
        isClient() &&
        window?._Cohesion?.anonymousId !== '' &&
        window?._Cohesion?.anonymousId !== undefined
      ) {
        clearInterval(annonymousIdInterval)
        resolve(window?._Cohesion?.anonymousId)
      } else if (tries <= 1) {
        clearInterval(annonymousIdInterval)
        resolve('')
      }
      tries--
    }, 300)
  })
}

const getLeadUsingHubInfo = async (
  lead_uuid,
  hubToken,
  origin,
  sourceUrlBase64,
  isEmailMarketingHub
) => {
  const makeAnnonymousId = await waitAnnonymousId()
  const correlationID = generateAndGetCorrelationId()

  const url = isEmailMarketingHub
    ? `/lead/remarketing/`
    : `/get_lead?lead_uuid=${lead_uuid}&token=${hubToken}&origin=${origin}&source_url=${sourceUrlBase64}&correlation_id=${correlationID}&make_anonymous_id=${makeAnnonymousId}`

  return signin('hub')
    .then(({ http }) => {
      isEmailMarketingHub
        ? (http.defaults.headers['Token'] = `Bearer ${hubToken}`)
        : null
      return http
        .get(url)
        .then((res) => {
          return res
        })
        .catch((e) => {
          console.error('error using getLeadUsingHubInfo', e)
        })
    })
    .catch((error) => {
      console.error('getHubInfo error -', error)
      throw error
    })
}

const getMarketplaceUrls = async (token) => {
  const systemToken = await getSystemTokenBFF()

  return signinIntegradora()
    .then(({ http }) => {
      http.defaults.headers['Token'] = `Bearer ${token}`
      http.defaults.headers['SystemToken'] = systemToken

      return http
        .get('/skipper/send-lead')
        .then((res) => {
          return res
        })
        .catch((error) => {
          console.error('send lead error -', error)
        })
    })
    .catch((error) => {
      console.error('error using getMarketplaceUrls -', error)
    })
}

export default { getLeadUsingHubInfo, getMarketplaceUrls }
